export var themeNamespace = '@atlaskit-shared-theme/button';